import axios from 'axios'
import store from './store.js'
import router from './router.js'
import { Toast, Dialog } from 'vant'
import client from './configs/client.js'
import { createLoading } from './components.js'
import { HOST } from '@/configs/xhconfig'

let http = axios.create({
    baseURL: HOST + '/api',
    headers: {
        'XinhuaApp': client.xinhua,
        'X-Requested-With': 'XMLHttpRequest'
    }
})

http.interceptors.request.use(
    (config) => {
        if (! store.state.identity) {
            store.commit('initIdentity');
        }
        config.headers.Spread = store.state.spread;
        config.headers.Identity = store.state.identity;
        config.headers.ReferrerUid = store.state.referrerUid;
        config.headers.Authorization = 'Bearer ' + store.state.authorization;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
)

http.interceptors.response.use(
    (response) => {
        complete();
        return response.data;
    },
    (error) => {
        complete();
        let data = error.response.data;
        if (error.response.status == 401) {
            let back = router.currentRoute.value.fullPath;
            if (error.response.data.data.info) {
                router.push('/auth?back=' + back);
            } else {
                /* eslint-disable */
                appContext.config.globalProperties.login(back);
                /* eslint-enable */
            }
        } else if (error.response.status == 422) {
            let message = '';
            for (let key in data.errors) {
                message += '<p>' + data.errors[key][0] + '</p>';
            }
            Dialog.alert({
                title: '错误提示',
                message: message,
                allowHtml: true
            })
        } else if (error.response.status == 429) {
            Toast.fail('请求过于频繁');
        } else if (data.message) {
            if (error.config.url.indexOf('product/') === 0) {
                // 藏品详情，如果没有拿到数据情况下，不要toast提示了，直接展示错误样式即可
                //if (data.code === 1031) {
                    Toast.fail(data.message);
                //}
            } else {
                Toast.fail(data.message);
            }
        }
        return Promise.reject(data);
    }
)

http.loading = function () {
    this.loadingDestroy = createLoading();
    return this;
}

http.put = function (path, data = {}) {
    data._method = 'PUT';
    return http.post(path, data);
}

http.delete = function (path, data = {}) {
    data._method = 'DELETE';
    return http.post(path, data);
}

function complete()
{
    if (typeof http.loadingDestroy == 'function') {
        http.loadingDestroy();
        delete http.loadingDestroy;
    }
}

export default http